<template>
  <div slot="content">
    <div>
      <div class="direct-chat-messages direct-chat-success">
        <div v-if="type=== 'post'" class="post-box">
          <a :href="refLink" target="_blank">{{ refLink }}</a>
        </div>
        <div class="direct-chat-msg" :class="{'right': message.type === 'right', 'left': message.type === 'left'}"
             v-for="message in messages"
             :key="message.id">
          <div class="direct-chat-info clearfix">
            <span class="direct-chat-name">{{
                message.from.name
              }}</span>

          </div>

          <img v-if="message.avatar && message.type === 'left'" class="direct-chat-img" :src="message.avatar"
               :alt="message.name">
          <img v-if="!message.avatar && message.type === 'left'" src="../../assets/icon/ava-user.jpg"
               class="direct-chat-img" :alt="message.name">

          <img v-if="message.avatar && message.type === 'right'" class="direct-chat-img" :src="message.avatar"
               :alt="message.name">
          <img v-if="!message.avatar && message.type === 'right'" src="../../assets/logo.png" class="direct-chat-img"
               :alt="message.name">
          <div class="direct-chat-text">
            {{ message.content }}
          </div>
          <span class="direct-chat-timestamp"><small>{{ message.create_date  | format_date_time }}</small></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Box from '../../components/Box'
import CrawlDataApi from '../../api/crawlDataApi'
import Utils from '../../common/utils'
import moment from 'moment/moment'

export default {
  name: 'ChatBox',
  props: {
    orderId: {
      type: Number,
      required: false
    }
  },
  components: {
    Box
  },
  data () {
    return {
      loading: false,
      messages: [],
      type: null,
      refLink: null,
    }
  },
  mounted () {
    this.loading = true
    if (this.orderId) {
      CrawlDataApi.getByOrder(this.orderId).then(res => {
        if (res.data && res.data.data && res.data.data.content) {
          this.type = res.data.data.type
          let listMessage = []
          let pivot = null
          this.refLink = res.data.data.ref_link
          if (this.type === 'msg') {
            JSON.parse(res.data.data.content).data.forEach(item => {
              if (!pivot) {
                pivot = item.from.name
              }
              listMessage.push({
                'id': item.id,
                'type': pivot === item.from.name ? 'right' : 'left',
                'content': item.message,
                'create_date': item.created_time,
                'avatar': item.avatar,
                'from': {
                  name: item.from.name,
                  email: item.from.email,
                  id: item.from.id
                }
              })
            })
            this.messages = listMessage.reverse()
          } else {
            const commentPost = JSON.parse(res.data.data.content)
            listMessage.push({
              'id': commentPost.id,
              'type': 'left',
              'content': commentPost.message,
              'create_date': commentPost.created_time,
              'avatar': commentPost.avatar,
              'from': {
                name: commentPost.from ? commentPost.from.name : '',
                email: commentPost.from ? commentPost.from.email : '',
                id: commentPost.from ? commentPost.from.id : ''
              }
            })
            commentPost.children.forEach(item => {
              if (!pivot) {
                pivot = item.from.name
              }
              listMessage.push({
                'id': item.id,
                'type': pivot === item.from.name ? 'left' : 'right',
                'content': item.message,
                'create_date': item.created_time,
                'avatar': item.avatar,
                'from': {
                  name: item.from.name,
                  email: item.from.email,
                  id: item.from.id
                }
              })
              this.messages = listMessage.sort((a, b) => moment(a.create_date).isAfter(moment(b.create_date)) ? 1 : -1)
            })
          }
        }
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    }
  },
  methods: {
    getAllCommentsInPost (treeStructure) {
      let flatten = (children, extractChildren) => Array.prototype.concat.apply(children, children.map(x => flatten(extractChildren(x) || [], extractChildren)))
      let extractChildren = x => x.children
      return flatten(extractChildren(treeStructure), extractChildren)
        .map(x => delete x.children && x)
    }
  }
}
</script>

<style scoped lang="scss">
.direct-chat-messages {
  height: 400px !important;
}

.direct-chat-text {
  border-radius: 5px;
  position: relative;
  padding: 7px;
  border: 1px solid rgba(241, 241, 241, .4);
  color: #444;
  width: auto;
  max-width: 70%;
  font-size: 95%;
  word-break: break-all;
}

.direct-chat-timestamp {
  margin-top: 5px;
  margin-left: 5px;
  margin-right: 5px;
}

.right {
  .direct-chat-info {
    .direct-chat-name {
      float: right;
    }
  }

  .direct-chat-timestamp {
    float: right;
  }

  .direct-chat-text {
    margin-right: 10px !important;
    float: right;
  }
}

.left {
  .direct-chat-timestamp {
    float: left;
  }

  .direct-chat-text {
    margin-left: 10px !important;
    float: left !important;
  }
}

.post-box {
  padding: 10px;
}

.comments {
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/order_management/ChatBox.vue